/* VeraPaws — Global JavaScript
   Initialised once on DOMContentLoaded.
   Sections append their own logic; this file handles global behaviours only.
*/

(function () {
  'use strict';

  /* ── Quiz modal — step-by-step routine finder ────
     Opens on any .js-quiz click.
     Closes on overlay click, [data-quiz-close], or Escape.
     Locks body scroll. Returns focus to trigger on close.
     Navigates through 7 screens: intro, steps 1–5, result.
  */
  function initQuizModal() {
    var modal = document.getElementById('vp-quiz-modal');
    if (!modal) return;

    var lastTrigger  = null;
    var currentScreen = 'intro';
    var screenHistory = [];

    /* Quiz state */
    var state = {
      dogName:     '',
      concern:     null,
      size:        null,
      age:         null,
      sensitivity: null,
      consistency: null
    };

    /* Step → state key mapping */
    var STEP_KEY = { '1': 'concern', '2': 'size', '3': 'age', '4': 'sensitivity', '5': 'consistency' };

    /* Serving guide by size */
    var SERVING = {
      'under5':  { serve: '½ teaspoon daily, approx. 1.5 g', duration: 'approx. 200 days' },
      '5to10':   { serve: '1 teaspoon daily, approx. 3 g',   duration: 'approx. 100 days' },
      '10to20':  { serve: '2 teaspoons daily, approx. 6 g',  duration: 'approx. 50 days'  },
      '20to30':  { serve: '3 teaspoons daily, approx. 9 g',  duration: 'approx. 33 days'  },
      'over30':  { serve: '4 teaspoons daily, approx. 12 g', duration: 'approx. 25 days'  },
      'unsure':  { serve: 'Use your dog\'s body weight as the guide. Start with the lowest suitable serve and build gradually.', duration: null }
    };

    var FOCUSABLE = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    /* ── Helpers ──────────────────────────────── */

    function dogLabel() {
      return state.dogName.trim() || 'your dog';
    }

    function updateDogNameSpans() {
      var spans = modal.querySelectorAll('.js-dog-name');
      var label = dogLabel();
      for (var i = 0; i < spans.length; i++) {
        spans[i].textContent = label;
      }
    }

    function getFormula() {
      if (state.concern === 'skin_coat') {
        return { name: 'Skin and Coat Collagen', handle: 'skin-and-coat-collagen-for-dogs' };
      }
      if (state.concern === 'joint') {
        return { name: 'Hip and Joint Collagen', handle: 'hip-joint-collagen-for-dogs' };
      }
      return { name: 'Premium Collagen', handle: 'multi-collagen-for-dogs-powder' };
    }

    function getRoutineSize() {
      if (state.consistency === 'gentle')  return 'Starter';
      if (state.consistency === 'stocked') return 'Consistency';
      return 'Daily';
    }

    function getFormulaBody(formulaName, dogName) {
      if (formulaName === 'Hip and Joint Collagen') {
        return 'Based on ' + dogName + '\'s profile, Hip and Joint Collagen is the best VeraPaws match for ' + dogName + '\'s daily routine. It is designed for dogs where healthy joints, everyday mobility, and daily movement support are the main focus, with collagen peptides plus MSM, glucosamine, and chondroitin.';
      }
      if (formulaName === 'Skin and Coat Collagen') {
        return 'Based on ' + dogName + '\'s profile, Skin and Coat Collagen is the best VeraPaws match for ' + dogName + '\'s daily routine. It is designed for dogs where healthy skin, coat condition, and everyday coat quality are the main focus, with collagen peptides plus MSM and biotin.';
      }
      return 'Based on ' + dogName + '\'s profile, Premium Collagen is the best VeraPaws match for ' + dogName + '\'s daily routine. It is our everyday collagen foundation, made with dual source bovine and marine collagen peptides for broad daily collagen support.';
    }

    function getSecondaryNote(routineSize) {
      if (routineSize === 'Daily') {
        return 'Want to stay stocked for longer? The Consistency Routine may be a better fit if you do not want to run out as quickly.';
      }
      if (routineSize === 'Starter') {
        return 'A gentle first pouch can be a good way to begin before building into a daily routine.';
      }
      return 'A good fit for larger dogs, senior dogs, multi-dog homes, or owners who want to stay stocked.';
    }

    function buildResultHTML() {
      var formula     = getFormula();
      var routineSize = getRoutineSize();
      var dogName     = dogLabel();
      var serving     = SERVING[state.size] || SERVING['unsure'];
      var body        = getFormulaBody(formula.name, dogName);
      var secondary   = getSecondaryNote(routineSize);
      var ctaLabel    = 'Start ' + (state.dogName.trim() ? state.dogName.trim() + '\'s' : 'the') + ' ' + routineSize + ' Routine';
      var headingName = state.dogName.trim() ? state.dogName.trim() : 'Your Dog';

      var durationItem = serving.duration
        ? '<div class="vp-quiz-result__card-item"><p class="vp-quiz-result__card-label">ONE POUCH LASTS</p><p class="vp-quiz-result__card-value">' + serving.duration + '</p></div>'
        : '';

      return (
        '<p class="vp-quiz-result__eyebrow">YOUR VERAPAWS ROUTINE MATCH</p>' +
        '<h2 class="vp-quiz-result__heading" id="vp-quiz-heading" tabindex="-1">' + headingName + '\'s Match</h2>' +
        '<p class="vp-quiz-result__formula-tag">' + formula.name + ' · ' + routineSize + ' Routine</p>' +
        '<p class="vp-quiz-result__body">' + body + '</p>' +
        '<div class="vp-quiz-result__card">' +
          '<div class="vp-quiz-result__card-item"><p class="vp-quiz-result__card-label">SUGGESTED DAILY SERVE</p><p class="vp-quiz-result__card-value">' + serving.serve + '</p></div>' +
          durationItem +
          '<div class="vp-quiz-result__card-item"><p class="vp-quiz-result__card-label">RECOMMENDED ROUTINE</p><p class="vp-quiz-result__card-value">' + routineSize + ' Routine</p></div>' +
        '</div>' +
        '<a class="vp-btn vp-btn--p vp-quiz-result__cta" href="/products/' + formula.handle + '">' + ctaLabel + '</a>' +
        '<p class="vp-quiz-result__secondary">' + secondary + '</p>' +
        '<p class="vp-quiz-result__disclaimer">Results vary from dog to dog. VeraPaws is nutritional support for dogs as part of a daily feeding routine, not a replacement for veterinary care.</p>' +
        '<button class="vp-quiz-result__restart" type="button" id="vp-quiz-restart">Start again</button>'
      );
    }

    /* ── Screen navigation ────────────────────── */

    function updateProgress(screenId) {
      var progress = document.getElementById('vp-quiz-progress');
      if (!progress) return;
      var stepNum = parseInt(screenId, 10);
      var isStep  = stepNum >= 1 && stepNum <= 5;
      var isResult = screenId === 'result';

      var isLoading = screenId === 'loading';
      if (isStep || isResult || isLoading) {
        progress.classList.add('is-visible');
        var segs = progress.querySelectorAll('.vp-quiz-progress__seg');
        var filled = (isResult || isLoading) ? 5 : stepNum;
        for (var i = 0; i < segs.length; i++) {
          if (i < filled) {
            segs[i].classList.add('is-filled');
          } else {
            segs[i].classList.remove('is-filled');
          }
        }
      } else {
        progress.classList.remove('is-visible');
      }
    }

    function showScreen(id) {
      var screens = modal.querySelectorAll('.vp-quiz-screen');
      for (var i = 0; i < screens.length; i++) {
        var s = screens[i];
        if (s.getAttribute('data-screen') === id) {
          s.hidden = false;
        } else {
          s.hidden = true;
        }
      }

      /* Populate result if needed */
      if (id === 'result') {
        var resultContent = document.getElementById('vp-quiz-result-content');
        if (resultContent) {
          resultContent.innerHTML = buildResultHTML();
          var restartBtn = document.getElementById('vp-quiz-restart');
          if (restartBtn) {
            restartBtn.addEventListener('click', resetQuiz);
          }
        }
      }

      updateProgress(id);
      currentScreen = id;

      /* Focus first focusable in new screen */
      requestAnimationFrame(function () {
        var screen = modal.querySelector('[data-screen="' + id + '"]');
        if (!screen) return;
        if (id === 'result') {
          var heading = screen.querySelector('[tabindex="-1"]');
          if (heading) heading.focus();
        } else {
          var first = screen.querySelector(FOCUSABLE);
          if (first) first.focus();
        }
        /* Scroll panel to top on screen change */
        var panel = modal.querySelector('.vp-quiz-modal__panel');
        if (panel) panel.scrollTop = 0;
      });
    }

    /* ── Loading → result transition ─────────── */

    function showLoadingThenResult(prevStep) {
      screenHistory.push(prevStep);
      showScreen('loading');

      /* Reset check states */
      var checks = modal.querySelectorAll('.vp-quiz-loading__item');
      for (var i = 0; i < checks.length; i++) {
        checks[i].classList.remove('is-active', 'is-done');
      }

      function getCheck(n) { return modal.querySelector('[data-check="' + n + '"]'); }

      setTimeout(function () {
        var c = getCheck(1); if (c) c.classList.add('is-active');
      }, 280);
      setTimeout(function () {
        var c = getCheck(1); if (c) { c.classList.remove('is-active'); c.classList.add('is-done'); }
        var c2 = getCheck(2); if (c2) c2.classList.add('is-active');
      }, 650);
      setTimeout(function () {
        var c = getCheck(2); if (c) { c.classList.remove('is-active'); c.classList.add('is-done'); }
        var c3 = getCheck(3); if (c3) c3.classList.add('is-active');
      }, 1020);
      setTimeout(function () {
        var c = getCheck(3); if (c) { c.classList.remove('is-active'); c.classList.add('is-done'); }
      }, 1320);
      setTimeout(function () {
        showScreen('result');
      }, 1500);
    }

    function resetQuiz() {
      state = { dogName: '', concern: null, size: null, age: null, sensitivity: null, consistency: null };
      screenHistory = [];
      /* Reset name input */
      var nameInput = document.getElementById('vp-quiz-name');
      if (nameInput) nameInput.value = '';
      updateDogNameSpans();
      showScreen('intro');
    }

    /* ── Open / close ─────────────────────────── */

    function openModal(triggerEl) {
      lastTrigger = triggerEl || null;
      resetQuiz();
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        var first = modal.querySelector(FOCUSABLE);
        if (first) first.focus();
      });
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    /* ── Event: open ──────────────────────────── */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-quiz') || e.target.closest('[data-quiz-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openModal(trigger);
    });

    /* ── Event: close ─────────────────────────── */
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-close]')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* ── Event: focus trap ────────────────────── */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = Array.from(modal.querySelectorAll(FOCUSABLE));
      if (!focusables.length) return;
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });

    /* ── Event: Start button (intro → step 1) ─── */
    modal.addEventListener('click', function (e) {
      if (!e.target.matches('#vp-quiz-start')) return;
      var nameInput = document.getElementById('vp-quiz-name');
      state.dogName = nameInput ? nameInput.value.trim() : '';
      updateDogNameSpans();
      screenHistory.push('intro');
      showScreen('1');
    });

    /* ── Event: option selection (auto-advance) ─ */
    modal.addEventListener('click', function (e) {
      var btn = e.target.closest('.vp-quiz-option');
      if (!btn) return;

      var optionsGroup = btn.closest('.vp-quiz-modal__options');
      if (!optionsGroup) return;

      var step = optionsGroup.getAttribute('data-step');
      var key  = STEP_KEY[step];
      if (!key) return;

      /* Mark selected visually */
      var siblings = optionsGroup.querySelectorAll('.vp-quiz-option');
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('is-selected');
      }
      btn.classList.add('is-selected');

      /* Store answer */
      state[key] = btn.getAttribute('data-answer');

      /* Advance after brief visual pause */
      var nextStep = parseInt(step, 10) + 1;
      var nextId   = nextStep <= 5 ? String(nextStep) : 'result';

      if (nextId === 'result') {
        setTimeout(function () { showLoadingThenResult(step); }, 180);
      } else {
        setTimeout(function () { screenHistory.push(step); showScreen(nextId); }, 180);
      }
    });

    /* ── Event: back button ───────────────────── */
    modal.addEventListener('click', function (e) {
      if (!e.target.matches('[data-quiz-back]')) return;
      var prev = screenHistory.pop();
      if (prev) showScreen(prev);
    });
  }

  /* ── Sticky header scroll class ─────────────────
     Adds .scrolled to .vp-header once the user
     scrolls past the announcement banner height.
  */
  function initStickyHeader() {
    var header = document.querySelector('.vp-header');
    if (!header) return;
    var handler = function () {
      header.classList.toggle('scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', handler, { passive: true });
    handler();
  }

  /* ── Init ────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initQuizModal();
    initStickyHeader();
  });

})();
